var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Post/Post.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/Post/Post.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Post/Post.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("macros", t_4);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 3;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
context.getSuper(env, "title", b_title, frame, runtime, function(t_11,hole_31) {
if(t_11) { cb(t_11); return; }
hole_31 = runtime.markSafe(hole_31);
output += runtime.suppressValue(hole_31, env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 3, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Bang! Bang! • "])), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "post")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"title"), env.opts.autoescape);
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <article class=\"Post\">\n        ";
var t_12;
t_12 = "post";
frame.set("mods", t_12, true);
if(frame.topLevel) {
context.setVariable("mods", t_12);
}
if(frame.topLevel) {
context.addExport("mods", t_12);
}
output += "\n        ";
output += runtime.suppressValue((lineno = 8, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"includeComponent"), "macros[\"includeComponent\"]", context, ["front/components/Common/TopBar/TopBar.jinja",[],runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "mods"),"caller": (function (){var macro_t_13 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_14 = "";;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
return macro_t_13;})()})])), env.opts.autoescape);
output += "\n\n        <h1>Статья</h1>\n        <h2 class=\"Post-title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "post")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"title"), env.opts.autoescape);
output += "</h2>\n        <p class=\"Post-date\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "post")),"publishedAt"), env.opts.autoescape);
output += "</p>\n        <p class=\"Post-description\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "post")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"description"), env.opts.autoescape);
output += "</p>\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "post")),"postId") > 0) {
output += "\n            <div class=\"Post-body\">\n                ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "post")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"body")), env.opts.autoescape);
output += "\n            </div>\n        ";
;
}
else {
output += "\n            <div class=\"Post-content\">\n                ";
frame = frame.push();
var t_17 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "post")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"blocks");
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("item", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n                    ";
if(runtime.memberLookup((t_18),"blockType") == 1) {
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_18),"text")), env.opts.autoescape);
;
}
output += "\n                    ";
if(runtime.memberLookup((t_18),"blockType") == 2) {
output += runtime.suppressValue((lineno = 22, colno = 70, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"image2x"), "macros[\"image2x\"]", context, [runtime.memberLookup((t_18),"image"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_20 = "";;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
return macro_t_19;})()})])), env.opts.autoescape);
;
}
output += "\n                    ";
if(runtime.memberLookup((t_18),"blockType") == 3) {
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_18),"embed")), env.opts.autoescape);
;
}
output += "\n                    ";
if(runtime.memberLookup((t_18),"blockType") == 4) {
output += "\n                        <div class=\"swiper-container\">\n                            <div class=\"swiper-wrapper\">\n                                ";
frame = frame.push();
var t_23 = (lineno = 27, colno = 57, runtime.callWrap(runtime.memberLookup((t_18),"get"), "item[\"get\"]", context, ["items"]));
if(t_23) {t_23 = runtime.fromIterator(t_23);
var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("slider", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += "\n                                    <div class=\"swiper-slide\">";
output += runtime.suppressValue((lineno = 28, colno = 82, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"image"), "macros[\"image\"]", context, [runtime.memberLookup((t_24),"image"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_25 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_26 = "";;
frame = frame.pop();
return new runtime.SafeString(t_26);
});
return macro_t_25;})()})])), env.opts.autoescape);
output += "</div>\n                                ";
;
}
}
frame = frame.pop();
output += "\n                            </div>\n                            <div class=\"swiper-button-next\"></div>\n                            <div class=\"swiper-button-prev\"></div>\n                        </div>\n                    ";
;
}
output += "\n                ";
;
}
}
frame = frame.pop();
output += "\n            </div>\n        ";
;
}
output += "\n    </article>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Post/Post.jinja"] , dependencies)